import { render, staticRenderFns } from "./ExperimentTeacher.vue?vue&type=template&id=57d673bd&scoped=true&"
import script from "./ExperimentTeacher.vue?vue&type=script&lang=js&"
export * from "./ExperimentTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentTeacher.vue?vue&type=style&index=0&id=57d673bd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d673bd",
  null
  
)

export default component.exports